import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function SalesChartSkeleton() {
  return <Skeleton variant="rectangular" animation="wave" width='100%' height={1100} />
}

export default SalesChartSkeleton;